// import React from "react";
// import { Col, Card, Upload, Button, Typography, Tag, Space } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import "./DocumentUploadCard.css";

// const { Title, Text } = Typography;

// const DocumentUploadCard = ({
//   title,
//   required = false,
//   formats = "PDF, XLS, XLSX",
//   maxSize = "350 KB",
//   icon,
//   fullWidth = false,
//   uploadProps = {},
//   fileList = [],
//   uploadedUrl = null,
// }) => {
//   return (
   
//       <Card
//         hoverable
//         className="document-upload-card"
//       >
//         <Space align="start" size={16} style={{ width: "48%" }}>
//           <div className="doc-icon">{icon}</div>

//           <div style={{ flex: 1 }}>
//             <Space align="center" style={{ marginBottom: 8 }}>
//               <Title level={5} style={{ margin: 0, fontSize: 15 }}>
//                 {title}
//               </Title>
//               {required && <Tag color="red">Required</Tag>}
//             </Space>

//             {!uploadedUrl && <Text type="secondary" style={{ display: "block", fontSize: 13 }}>
//               Format: {formats}    • Max {maxSize}
//             </Text>}

//             <Upload
//               {...uploadProps}
//               fileList={fileList}
//             >
//               {!uploadedUrl && (
//                 <Button
//                   type="primary"
//                   icon={<UploadOutlined />}
//                   block
//                   style={{ marginTop: 16 }}
//                 >
//                   Upload File
//                 </Button>
//               )}
//             </Upload>
//           </div>
//         </Space>
//       </Card>
    
//   );
// };

// export default DocumentUploadCard;

// import React from "react";
// import { Card, Upload, Button, Typography, Tag, Space } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import "./DocumentUploadCard.css";

// const { Title, Text } = Typography;

// const DocumentUploadCard = ({
//   title,
//   required = false,
//   formats = "PDF, XLS, XLSX",
//   maxSize = "350 KB",
//   icon,
//   uploadProps = {},
//   fileList = [],
//   uploadedUrl = null,
// }) => {
//   return (
//     <Card hoverable className="document-upload-card">
//       <div className="document-card-content">
//         <div className="doc-icon">{icon}</div>

//         <div className="doc-body">
//           <div className="doc-header">
//             <Title level={5}>{title}</Title>
//             {required && <Tag color="red">Required</Tag>}
//           </div>

//           {!uploadedUrl && (
//             <Text type="secondary" className="doc-meta">
//               Format: {formats} • Max {maxSize}
//             </Text>
//           )}

//           <Upload {...uploadProps} fileList={fileList}>
//             {!uploadedUrl && (
//               <Button type="default" icon={<UploadOutlined />}>
//                 Upload File
//               </Button>
//             )}
//           </Upload>
//         </div>
//       </div>
//     </Card>
//   );
// };

// export default DocumentUploadCard;

import React from "react";
import { Upload, Button, Typography } from "antd";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import "./DocumentUploadCard.css";
import {
    FileOutlined,
    FilePdfOutlined,
    FileImageOutlined,
} from '@ant-design/icons';
const { Text } = Typography;

const DocumentUploadCard = ({
  title,
  formats = "PDF, XLS, XLSX",
  maxSize = "350 KB",
  uploadProps = {},
  fileList = [],
  uploadedUrl = null,
  isDemoDownloadRequired = false,
}) => {
  return (
    <div className="custom-upload-card-wrapper">
      {/* Title and Metadata */}
      <div className="upload-card-info">
        <Text className="upload-card-title">{title}</Text>
        {!uploadedUrl && (
          <Text className="upload-card-meta">
            Format: {formats}
          </Text>
        )}
      </div>

      {
        isDemoDownloadRequired && (
          <Button
            type="link"
            className="pfs-template-link"
            icon={<DownloadOutlined />}
            onClick={() =>
              window.open("PersonalFinancialStatement.xlsx", "_blank")
            }
          >
            Download PFS Template
          </Button>
        )
      }

      {/* Dashed Upload Button Area */}
      <Upload {...uploadProps} fileList={fileList} className="full-width-upload"
        iconRender={() => (
            <img src="/SVG.svg" alt="icon" />
        )}
      >
        {!uploadedUrl && (
          <Button 
            className="dashed-upload-area" 
            icon={<UploadOutlined className="upload-icon-style" />}
          >
            Upload File
          </Button>
        )}
      </Upload>
    </div>
  );
};

export default DocumentUploadCard;